import { gql } from "@lytra/frontend-common/__generated__";

// These went through raw `graphql-tag` with hand-written result interfaces, which is why
// the presence hook needed a cast: nothing tied those interfaces to the schema. They are
// ordinary Jupiter operations, so they belong in the generated document registry like
// every other one, and their result types now come from the schema rather than being
// retyped by hand. The hand-written types also claimed the query and the subscription
// returned the same type — the schema has the query yielding AgentPresenceEntry and the
// subscription yielding AgentPresenceEvent.
export const AGENT_PRESENCE_QUERY = gql(`
  query AgentPresence {
    agentPresence {
      agentId
      displayName
      conversationId
      source
      activity
    }
  }
`);

export const AGENT_PRESENCE_SUBSCRIPTION = gql(`
  subscription AgentPresenceUpdated {
    agentPresenceUpdated {
      agentId
      displayName
      conversationId
      source
      activity
    }
  }
`);

// Typing in the answer draft: shows the agent as working on the ticket, like a saved
// change to the answer does. Carries no text.
export const MARK_WORKING_MUTATION = gql(`
  mutation MarkWorking($messageId: UUID!) {
    messageMarkWorking(messageId: $messageId)
  }
`);
